import * as XLSX from 'xlsx';
import { IBalanceMovement } from '../../@types/Dashboard/IBalanceMovement';
import { formatDateReport, parseUtcDate } from '../date/formatedDate';
import { applyColumnWidths } from './columnWidthCalculator';

type ITransformedBalanceMovement = Record<string, string | number>;

const emptyValue = (value?: string | null) => value || '-';

const getBatchInitials = (item: IBalanceMovement) => {
  if (!item.batch_initials) return '-';
  if (!item.farm_initials || !item.area_initials) return item.batch_initials;
  if (item.batch_initials.includes(`${item.farm_initials}-${item.area_initials}`)) return item.batch_initials;

  return `${item.farm_initials}-${item.area_initials}-${item.batch_initials}`;
};

const transformDataForExport = (data: IBalanceMovement[]): ITransformedBalanceMovement[] => {
  return data.map((item) => ({
    'Data': formatDateReport(parseUtcDate(item.date)),
    'Fazenda': item.farm_name,
    'Área': item.area_name,
    'Lote': getBatchInitials(item),
    'Tipo de movimentação': item.movement_type,
    'Categoria': item.category,
    'Quantidade': item.quantity,
    'Saldo final': item.end_balance,
    'Origem': emptyValue(item.origin),
    'Destino': emptyValue(item.destination),
    'Tipo de venda': emptyValue(item.sale_type),
    'Causa da morte': emptyValue(item.death_cause),
    'Comentário': emptyValue(item.comment)
  }));
};

export const exportBalanceMovementToExcel = (data: IBalanceMovement[], filename?: string) => {
  if (!data || data.length === 0) {
    alert("Nenhum dado disponível para exportação");
    return;
  }

  const sortedData = [...data].sort(
    (a, b) => (parseUtcDate(a.date)?.getTime() ?? 0) - (parseUtcDate(b.date)?.getTime() ?? 0)
  );
  const transformedData = transformDataForExport(sortedData);

  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  transformedData.forEach((_, index) => {
    const cell = worksheet[`G${index + 2}`];
    if (cell) cell.z = '+0;-0;0';
  });

  applyColumnWidths(worksheet, transformedData, { padding: 2, min: 8, max: 60 });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Movimentação');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || `movimentacao-gado-${new Date().toISOString().split('T')[0]}.xlsx`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
